import React from 'react';
import { Flex } from '@wegroup/design-system';
import CompanyScanSmallToolbar from '../small-toolbar/CompanyScanSmallToolbar';

const CompanyScanAppShell: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <Flex
      flexDir={{ base: 'column', laptop: 'row' }}
      h="100%"
      w="100%"
      bg="#fdfcff"
      position="relative"
    >
      <CompanyScanSmallToolbar />
      <Flex
        flexGrow={1}
        // Temporary hardcoded because time
        h={{ base: 'calc(100% - 104px)', laptop: '100%' }}
        w="100%"
        position="relative"
        flexDir="column"
      >
        {children}
      </Flex>
    </Flex>
  );
};

export default CompanyScanAppShell;
